(function () {
  'use strict';

  var KEY = 'ac_cookie_consent_v1';
  var VERSION = 1;
  var CHANGE_EVENT = 'ac-cookie-consent-changed';
  var SETTINGS_EVENT = 'ac-cookie-settings';

  function readConsent() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!parsed || parsed.version !== VERSION) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(analytics, marketing) {
    var consent = {
      version: VERSION,
      necessary: true,
      analytics: !!analytics,
      marketing: !!marketing,
      savedAt: new Date().toISOString()
    };
    localStorage.setItem(KEY, JSON.stringify(consent));
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: consent }));
    applyConsent(consent);
    return consent;
  }

  function gtagUpdate(consent) {
    var gtag = window.gtag;
    if (typeof gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      gtag = function () { window.dataLayer.push(arguments); };
      window.gtag = gtag;
    }
    var ads = consent.marketing ? 'granted' : 'denied';
    gtag('consent', 'update', {
      analytics_storage: consent.analytics ? 'granted' : 'denied',
      ad_storage: ads,
      ad_user_data: ads,
      ad_personalization: ads
    });
  }

  function shopifyConsent(consent) {
    function set() {
      if (!window.Shopify || !window.Shopify.customerPrivacy || typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') {
        return;
      }
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: false,
        sale_of_data: false
      }, function () {});
    }
    if (window.Shopify && window.Shopify.customerPrivacy) {
      set();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) set();
      });
    }
  }

  var pixelLoaded = false;
  function loadMetaPixel() {
    if (pixelLoaded || !window.AC_META_PIXEL_ID) return;
    if (window.fbq) {
      pixelLoaded = true;
      window.fbq('consent', 'grant');
      window.fbq('track', 'PageView');
      return;
    }
    pixelLoaded = true;
    var n;
    var f = window;
    var b = document;
    var e = 'script';
    var v = 'https://connect.facebook.net/en_US/fbevents.js';
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    var t = b.createElement(e);
    t.async = true;
    t.src = v;
    var s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
    window.fbq('consent', 'grant');
    window.fbq('init', String(window.AC_META_PIXEL_ID));
    window.fbq('track', 'PageView');
  }

  function applyConsent(consent) {
    gtagUpdate(consent);
    shopifyConsent(consent);
    if (consent.marketing) loadMetaPixel();
  }

  function qs(id) {
    return document.getElementById(id);
  }

  function show(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function initUi() {
    var root = qs('ac-cookie-banner');
    var main = qs('ac-cookie-main');
    var prefs = qs('ac-cookie-prefs');
    var cbA = qs('ac-cookie-analytics');
    var cbM = qs('ac-cookie-marketing');
    if (!root) return;

    function openBanner(panel) {
      show(root, true);
      document.body.style.overflow = 'hidden';
      if (panel === 'prefs') {
        show(main, false);
        show(prefs, true);
        var existing = readConsent();
        if (cbA) cbA.checked = !!(existing && existing.analytics);
        if (cbM) cbM.checked = !!(existing && existing.marketing);
      } else {
        show(main, true);
        show(prefs, false);
      }
    }

    function closeBanner() {
      show(root, false);
      document.body.style.overflow = '';
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ac-cookie]');
      if (!btn) return;
      var action = btn.getAttribute('data-ac-cookie');
      if (action === 'accept-all') {
        saveConsent(true, true);
        closeBanner();
      } else if (action === 'reject') {
        saveConsent(false, false);
        closeBanner();
      } else if (action === 'prefs') {
        openBanner('prefs');
      } else if (action === 'back') {
        openBanner('banner');
      } else if (action === 'save') {
        saveConsent(cbA ? cbA.checked : false, cbM ? cbM.checked : false);
        closeBanner();
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-ac-cookie-settings]')) {
        e.preventDefault();
        openBanner('prefs');
      }
    });

    window.addEventListener(SETTINGS_EVENT, function () {
      openBanner('prefs');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) {
        if (readConsent()) closeBanner();
        else openBanner('banner');
      }
    });

    var existing = readConsent();
    if (existing) {
      applyConsent(existing);
      closeBanner();
    } else {
      shopifyConsent({ analytics: false, marketing: false });
      openBanner('banner');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUi);
  } else {
    initUi();
  }
})();
